"use client";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProductPreview from "@/app/components/pages/shop/ProductPreview";
import styles from "@/app/styles/components/common/product-slider.module.scss";

const ProductSlider = ({ products, title }) => {
  const renderProducts = (products) => {
    if (!products) {
      return "";
    }

    let result = [];

    for (let product of products) {
      result.push(
        <ProductPreview
          key={"product-slider-" + product.id}
          product={product}
        />
      );
    }

    return result;
  };

  const settings = {
    dots: true,
    infinite: false,
    className: styles.productSlider,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1220,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  };

  if(!products || products.length === 0) {
    return ''
  }

  return (
    <div className={styles.productSliderContainer}>
      {title && <h3>{title}</h3>}

      <Slider {...settings}>{renderProducts(products)}</Slider>
    </div>
  );
};

export default ProductSlider;
